import { NgIf, NgTemplateOutlet } from '@angular/common';
import { inject, Component, HostListener, Inject, TemplateRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ButtonComponent } from '@common-components/button/button.component';
import { CloseBtnComponent } from '@common-components/close-btn/close-btn.component';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [
    NgIf,
    NgTemplateOutlet,
    CloseBtnComponent,
    ButtonComponent,
    MatDialogModule
  ],
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {

  public data = inject(MAT_DIALOG_DATA);

  private delete = new BehaviorSubject<boolean>(false);
  public deleteObs = this.delete.asObservable();

  isLoading;
  @ViewChild('deleteTemplate', { static: true }) deleteTemplate: TemplateRef<any>;

  @HostListener('keydown.esc')
  public onEsc() {
  }

  ngOnInit() {
    if (this.data.type === 'confirmDelete') {
      this.data.content = this.deleteTemplate;
    }
  }

  deleteComment(): void {
    this.delete.next(true);
  }

  cancelDelete(): void {
  }

}
